export const withRetries = async <T>(
    options: { retries: number },
    request: () => Promise<T>
) => {
    const aggregateErrors = [];

    for (let attempt = 1; attempt <= options.retries; attempt++) {
        try {
            return await request();
        } catch (error) {
            aggregateErrors.push(error);
        }
    }

    throw new Error(`Failed after ${options.retries} retries: ${aggregateErrors.join(', ')}`);
};